import { render } from "./AccountView.vue?vue&type=template&id=a750e462"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/AccountView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a750e462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a750e462', __exports__)) {
    api.reload('a750e462', __exports__)
  }
  
  module.hot.accept("./AccountView.vue?vue&type=template&id=a750e462", () => {
    api.rerender('a750e462', render)
  })

}


export default __exports__